@if ((manager().mode | async) === 'view') {
  <button mat-stroked-button (click)="manager().mode.next('edit')">
    <mat-icon>edit</mat-icon>
    {{ 'button.edit' | translate }}
  </button>
} @else {
  <div class="d-flex gap-10">
    <button matButton="tonal" (click)="manager().cancelClicked.next()">
      {{ 'button.cancel' | translate }}
    </button>
    <button mat-flat-button (click)="manager().saveClicked.next()">
      <mat-icon>save</mat-icon>
      {{ 'button.save' | translate }}
    </button>
    <button mat-stroked-button (click)="manager().addClicked.next()">
      <mat-icon>dashboard_customize</mat-icon>
      {{ 'page.widgetContent.addWidget' | translate }}
    </button>
  </div>
}
